// extracted by mini-css-extract-plugin
export default {"addSection":"ViewerContentSection_addSection__CSP6t","addSectionContainer":"ViewerContentSection_addSectionContainer__g2Wge"};